import { render, staticRenderFns } from "./QuestionsOfTheDay.vue?vue&type=template&id=2ef5f1b4&scoped=true&"
import script from "./QuestionsOfTheDay.vue?vue&type=script&lang=js&"
export * from "./QuestionsOfTheDay.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsOfTheDay.vue?vue&type=style&index=0&id=2ef5f1b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5f1b4",
  null
  
)

export default component.exports